import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import { Link } from 'react-router-dom';
import image1 from "../../assets/globalImgs/profile.png";
import Select from 'react-select';

const Profilesearch = () => {
    const [empId, setEmpId] = useState('');
    const [skill, setSkill] = useState('');
    const [searchType, setSearchType] = useState('empId');
    const [profile, setProfile] = useState(null);
    const [skillResults, setSkillResults] = useState([]);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleErrors = useHandleErrors();
    const [hierarchyDetails, setHierarchyDetails] = useState([]);
    const [searchPerformed, setSearchPerformed] = useState(false);
    const ClearIndicator = () => null;
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleSearch = async () => {
        setLoading(true);
        setSearchPerformed(true);
        const token = localStorage.getItem("token");
        try {
            if (searchType === 'empId') {
                if (!empId) {
                    toast.error("Search cannot be empty.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                    setLoading(false);
                    return;
                }
                const profilePath = `/profileSearch?employeeDetails=${empId}`;
                const profileURL = process.env.REACT_APP_BE_URL + profilePath;
                const profileResponse = await axios.get(profileURL, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (profileResponse.status === 200) {
                    if (profileResponse?.data?.profileSearches?.length === 0) {
                        toast.error(profileResponse?.data?.Status, {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    } else {
                        setProfile(profileResponse.data.profileSearches[0]);
                        setSkillResults([]);
                    }
                } else {
                    handleErrors(profileResponse);
                }

                const hierarchyPath = `/hierarcy?employeeId=${empId}`;
                const hierarchyURL = process.env.REACT_APP_BE_URL + hierarchyPath;
                const hierarchyResponse = await fetch(hierarchyURL, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const hierarchyData = await hierarchyResponse.json();

                if (hierarchyResponse.status === 200) {
                    setHierarchyDetails(hierarchyData.HierarcyDetails);
                } else {
                    handleErrors(hierarchyResponse);
                }
            } else {
                if (!skill) {
                    toast.error("Skill search cannot be empty.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                    setLoading(false);
                    return;
                }
                const skillPath = `/profileSearch?skillS=${skill}`;
                const skillURL = process.env.REACT_APP_BE_URL + skillPath;
                const skillResponse = await axios.get(skillURL, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (skillResponse.status === 200) {
                    if (skillResponse?.data?.profileSearches?.length === 0) {
                        toast.error("No profiles found for this skill.", {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    } else {
                        setSkillResults(skillResponse.data.profileSearches);
                        setProfile(null);
                        setHierarchyDetails([]);
                    }
                } else {
                    handleErrors(skillResponse);
                }
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setProfile(null);
                    setSkillResults([]);
                    setHierarchyDetails([]);
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
        setLoading(false);
    };

    const handleViewProfile = async (employeeId) => {
        setLoading(true);
        const token = localStorage.getItem("token");
        try {
            const profilePath = `/profileSearch?employeeDetails=${employeeId}`;
            const profileURL = process.env.REACT_APP_BE_URL + profilePath;
            const profileResponse = await axios.get(profileURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (profileResponse.status === 200) {
                if (profileResponse?.data?.profileSearches?.length === 0) {
                    toast.error(profileResponse?.data?.Status, {
                        position: toast.POSITION.TOP_CENTER,
                    });
                } else {
                    setSelectedProfile(profileResponse.data.profileSearches[0]);
                    setProfile(null);
                    setSkillResults([]);
                }
            } else {
                handleErrors(profileResponse);
            }

            const hierarchyPath = `/hierarcy?employeeId=${employeeId}`;
            const hierarchyURL = process.env.REACT_APP_BE_URL + hierarchyPath;
            const hierarchyResponse = await fetch(hierarchyURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const hierarchyData = await hierarchyResponse.json();

            if (hierarchyResponse.status === 200) {
                setHierarchyDetails(hierarchyData.HierarcyDetails);
            } else {
                handleErrors(hierarchyResponse);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
        setLoading(false);
    };

    const searchTypeOptions = [
        { value: "empId", label: "Employee ID" },
        { value: "skills", label: "Skills" },
    ];

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = skillResults.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(skillResults.length / recordsPerPage);


    const paginate = pageNumber => setCurrentPage(pageNumber);

    return (
        <div>
            <div className="content-page">
                <ToastContainer />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row mb-2">
                                <div className="col">
                                    <h3 className="title mb-2">Profile</h3>
                                </div>
                                <div className="col-auto">
                                    <Link to={'/SubmitTimesheet'} className="btn btn-primary mt-lg-0 mt-4">
                                        <i className="ri-calendar-schedule-fill"></i> Timesheet
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="profile-detail">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-lg-6 col-md-8 col-sm-10">
                                                <div className="container-fluid row-rounded mb-0 mt-4">
                                                    <div className="row px-2 py-0">
                                                        <div className="input-group mb-0">
                                                            <div className="input-group-prepend">
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="searchType"
                                                                    value={
                                                                        searchTypeOptions.find(
                                                                            (option) => option.value === searchType
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setSearchType(selectedOption ? selectedOption.value : "")
                                                                    }
                                                                    options={searchTypeOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />

                                                            </div>
                                                            {searchType === 'empId' ? (
                                                                <input
                                                                    type="search"
                                                                    className="form-control"
                                                                    placeholder="Enter Employee ID, Name..."
                                                                    value={empId}
                                                                    onChange={(e) => setEmpId(e.target.value)}
                                                                />
                                                            ) : (
                                                                <input
                                                                    type="search"
                                                                    className="form-control"
                                                                    placeholder="Enter Skill..."
                                                                    value={skill}
                                                                    onChange={(e) => setSkill(e.target.value)}
                                                                />
                                                            )}
                                                            <div className="input-group-append">
                                                                <button
                                                                    className="btn btn-primary"
                                                                    type="button"
                                                                    id="search-profile"
                                                                    title="Search"
                                                                    rel="tooltip"
                                                                    onClick={handleSearch}
                                                                    disabled={loading}
                                                                >
                                                                    {loading ? 'Searching...' : <i className="ri-menu-search-line"></i>}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <small className="form-text text-muted text-center mt-0">
                                                    <i className="ri-information-2-fill text-info"></i>
                                                    {searchType === 'empId'
                                                        ? ' Allows: User ID - First Name - Last Name - Preferred Name'
                                                        : ' Enter a skill to find employees'}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {searchPerformed ? (
                            searchType === 'skills' && skillResults.length > 0 ? (
                                <div className="col-lg-12">
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col">
                                                    <h5 className="title mt-1 mb-0">Skill Wise List</h5>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="table-responsive asset-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>Employee ID</th>
                                                                    <th>Name</th>
                                                                    <th>Department</th>
                                                                    <th>Designation</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords.map((result, index) => (
                                                                    <tr key={index}>
                                                                        <td>{result.employeeId}</td>
                                                                        <td>{result.firstName} {result.lastName}</td>
                                                                        <td>{result.department}</td>
                                                                        <td>{result.designation}</td>
                                                                        <td>
                                                                            <button
                                                                                className="btn btn-secondary"
                                                                                onClick={() => handleViewProfile(result.employeeId)}
                                                                                disabled={loading}
                                                                            >
                                                                                View
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (profile || selectedProfile) ? (
                                <div className="col-lg-12">
                                    <div className="row" id="profile-results">
                                        <div className="col-lg-8">
                                            <div className="card mb-4">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-lg-4 col-md-12">
                                                            <div className="user-info">
                                                                <div className="profile-detail">
                                                                    <div className="user-profile-pic">
                                                                        <img
                                                                            src={(profile || selectedProfile).image}
                                                                            className="img-fluid"
                                                                            alt="Profile"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-8 col-md-12">
                                                            <div className="mt-3 mb-3">
                                                                <h4 className="text-primary">
                                                                    {(profile || selectedProfile).firstName}{' '}
                                                                    {(profile || selectedProfile).middleName}{' '}
                                                                    {(profile || selectedProfile).lastName}
                                                                </h4>
                                                                <h5 className="text-secondary">
                                                                    {(profile || selectedProfile).employeeId}
                                                                </h5>
                                                                <p>
                                                                    Since{' '}
                                                                    {moment(
                                                                        (profile || selectedProfile).dateOfJoining
                                                                    ).format('DD-MM-YYYY')}
                                                                </p>
                                                            </div>
                                                            <div className="row mt-3">
                                                                <div className="col-md-6 col-lg-6 col-sm-12">
                                                                    <small className="form-text text-muted mb-2">
                                                                        Official Email
                                                                    </small>
                                                                    <h6>
                                                                        {(profile || selectedProfile).officialEmail}
                                                                    </h6>
                                                                </div>
                                                                <div className="col-md-6 col-lg-6 col-sm-12">
                                                                    <small className="form-text text-muted mb-2">
                                                                        Contact Number
                                                                    </small>
                                                                    <h6>
                                                                        {(profile || selectedProfile).contactNumber}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div className="row">
                                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                                            <small className="form-text text-muted mb-2">
                                                                Employment Type
                                                            </small>
                                                            <h6>
                                                                {(profile || selectedProfile).employeeType}
                                                            </h6>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                                            <small className="form-text text-muted mb-2">
                                                                Department
                                                            </small>
                                                            <h6>
                                                                {(profile || selectedProfile).department}
                                                            </h6>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                                            <small className="form-text text-muted mb-2">
                                                                Designation
                                                            </small>
                                                            <h6>
                                                                {(profile || selectedProfile).designation}
                                                            </h6>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                                            <small className="form-text text-muted mb-2">
                                                                Work Location
                                                            </small>
                                                            <h6>
                                                                {(profile || selectedProfile)
                                                                    ?.addressDetailsList?.CurrentAddress[0]?.TownCity}
                                                            </h6>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                                            <small className="form-text text-muted mb-2">
                                                                Date of Birth
                                                            </small>
                                                            <h6>
                                                                {moment(
                                                                    (profile || selectedProfile).dateOfBirth
                                                                ).format("DD-MM-YYYY")}
                                                            </h6>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                                            <small className="form-text text-muted mb-2">
                                                                Blood Group
                                                            </small>
                                                            <h6>
                                                                {(profile || selectedProfile).bloodGroup}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div className="row align-items-center text-center py-2">
                                                        <div className="profile-info col-xl-3 col-lg-6 col-md-3 col-sm-6">
                                                            <div className="profile-icon rounded m-auto bg-info">
                                                                <i className="ri-hand"></i>
                                                            </div>
                                                            <h5 className="mb-2 mt-3 icon-text-danger">
                                                                {(profile || selectedProfile).experience || "0"} years
                                                            </h5>
                                                            <p className="mb-0">Experience</p>
                                                        </div>
                                                        <div className="profile-info col-xl-3 col-lg-6 col-md-3 col-sm-6">
                                                            <div className="profile-icon rounded m-auto bg-warning">
                                                                <i className="ri-medal-line"></i>
                                                            </div>
                                                            <h5 className="mb-2 mt-3 icon-text-warning">
                                                                {(profile || selectedProfile).achievements?.length || 0}
                                                            </h5>
                                                            <p className="mb-0">Achievements</p>
                                                        </div>
                                                        <div className="profile-info col-xl-3 col-lg-6 col-md-3 col-sm-6" style={{ color: 'gray' }}>
                                                            <div className="profile-icon rounded m-auto bg-success" style={{ backgroundColor: 'lightgray' }}>
                                                                <i className="ri-code-box-line"></i>
                                                            </div>
                                                            <h5 className="mb-2 mt-3 icon-text-info">
                                                                {(profile || selectedProfile).certificates || 0}
                                                            </h5>
                                                            <p className="mb-0">Certificates</p>
                                                        </div>
                                                        <div className="profile-info col-xl-3 col-lg-6 col-md-3 col-sm-6" style={{ color: 'gray' }}>
                                                            <div className="profile-icon rounded m-auto bg-danger" style={{ backgroundColor: 'lightgray' }}>
                                                                <i className="ri-verified-badge-line"></i>
                                                            </div>
                                                            <h5 className="mb-2 mt-3 icon-text-success">
                                                                {(profile || selectedProfile).participations || 0}
                                                            </h5>
                                                            <p className="mb-0">Participations</p>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <h6>Skills</h6>
                                                    <div className="row skills-list">
                                                        {(profile || selectedProfile)?.skills?.map((skill, index) => (
                                                            <div className="col-lg-6 mt-2 mb-2" key={index}>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="skill-icon-box rounded">
                                                                        Sk
                                                                    </div>
                                                                    <div className="ml-3 w-100">
                                                                        <div className="media align-items-center justify-content-between">
                                                                            <p className="mb-0">{skill}</p>
                                                                        </div>
                                                                        <div className="progress">
                                                                            <div
                                                                                className="progress-bar bg-info"
                                                                                role="progressbar"
                                                                                style={{ width: `${skill.proficiency}%` }}
                                                                                aria-valuenow={skill.proficiency}
                                                                                aria-valuemin="0"
                                                                                aria-valuemax="100"
                                                                            ></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="card ww-app-bg">
                                                <div className="card-body">
                                                    <span><i className="ri-node-tree"></i></span>
                                                </div>
                                            </div>
                                            <div className="card mb-4">
                                                <div className="card-body">
                                                    <h4 className="mb-2">Hierarchy</h4>
                                                    <div className="card-body p-0">
                                                        <ul className="list-inline p-0 m-0 mt-4 w-100 emp-hierarchy-view">
                                                            {hierarchyDetails.map((detail, index) => (
                                                                <li key={index}>
                                                                    <div className="row align-items-top emp-hierarchy-content no-gutters">
                                                                        <div className="col-auto">
                                                                            <div className="emp-hierarchy-pic">
                                                                                <img
                                                                                    src={image1}
                                                                                    className="img-fluid"
                                                                                    alt="Profile"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col pl-2">
                                                                            <div className="emp-hierarchy-info">
                                                                                <h6 className="mb-1">{detail.EmployeeID}</h6>
                                                                                <span>{detail.EmployeeEmail}</span>
                                                                                <span>{detail.ManagerEmail}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="card-body search-profile-section" id="search-profile-note">
                                    <div className="row justify-content-center mt-5 mb-5">
                                        <div className="col text-center">
                                            <h1><i className="ri-user-search-line"></i></h1>
                                            <span>No data found</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        ) : (
                            <div className="card-body search-profile-section" id="search-profile-note">
                                <div className="row justify-content-center mt-5 mb-5">
                                    <div className="col text-center">
                                        <h1><i className="ri-user-search-line"></i></h1>
                                        <span>Search your colleagues</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profilesearch;